<template>
 <div id="programme">
   <section class="banner">
     <img src="../assets/image/page-banner.png"/>
      <div class="text">
        <div>
          <P>为企业提供一站式福利解决方案</P>
        </div>
      </div>
   </section>
   <section class="tab">
     <div class="center">
       <ul>
         <li class="lf" :class="[nowPro === i ? 'active' : '']" v-for="(t, i) in programmeArr" :key="i" @mouseenter="proEnter(i)">
           <img :src="require('@/assets/image/'+(nowPro === i ? 'pro-act' : 'pro')+(i+1)+'.png')"/>
           <span> {{t}}</span>
         </li>
       </ul>
     </div>
   </section>
   <article class="intro">
     <div class="center">
       <h3>{{introArr[nowPro].title}}</h3>
       <div class="content">
         <p>{{introArr[nowPro].text}}</p>
       </div>
     </div>
   </article>
   <component :is="comName" :type="type"></component>
   <section class="guard">
     <div class="center">
       <h3>服务保障</h3>
       <div class="content">
         <ul>
           <li class="lf" v-for="(t, index) in guardArr" :key="index">
             <div class="lf msg">
               <img :src="require('@/assets/image/guard'+ (index+1) + '.png')"/>
               <p>{{t.title}}</p>
             </div>
             <div class="lf list">
               <span v-for="(p, i) in t.text" :key="i">{{p}}</span>
             </div>
           </li>
         </ul>
       </div>
     </div>
   </section>
 </div>
</template>
<script>
import Compare from '../components/Compare'
import Mall from '../components/Mall'
import Care from '../components/Care'
import Welfare from '../components/Welfare'
import Stimulate from '../components/Stimulate'
export default {
  name: 'Programme',
  data() {
    return {
      programmeArr: [
        '弹性福利',
        '补贴福利',
        '健康体检',
        '员工关怀',
        '员工激励',
        '福利商城'
      ],
      nowPro: 0,
      guardArr: [
        { title: '热线电话', text: ['7*10小时 周一 到 周日', '电话接听率95%以上', '80%皆可在20秒内应答', '往年好评98%以上'] },
        { title: '物流配送', text: ['48小时发货', '商家直邮', '全国包邮', '配送到家', '物流查询'] },
        { title: '售后处理', text: ['确认问题后 先赔付 再处理', '联系客服 即可进行咨询与投诉', '2小时内反馈', '1-3个工作日必定解决'] }
      ],
      introArr: [
        { title: '关于弹性福利', text: '不同于传统福利安排，弹性福利以积分形式为企业自主充值、为员工定向分配。由员工在福利菜单中选择适合自己的福利，因此也叫菜单式福利。弹性福利的出现，在很大程度上解决企业成本管理和员工满意度的矛盾。' },
        { title: '关于补贴福利', text: '企业福利助手通过整合优质供应商资源，提供全方位定制化企业补贴解决方案，涵盖餐费、通讯、交通等多类日常补贴。一站式服务，有效节约企业成本，提高员工所得收入。' },
        { title: '关于健康体检', text: '国内专业的互联网医疗+健康管理信息一体化服务平台，运用互联网高科技，率先实现与国内众多医院和体检机构数据平台打通，实现智能预约模式。提供企业员工体检咨询与专业的体检套餐设计，及检后报告专家解读与数据分析服务。' },
        { title: '关于员工关怀', text: '员工年龄层次逐渐趋于年轻化、单一化福利场景已无法满足员工需求。从员工职业周期、员工个人关怀、年度时间周期切入，打造个性化福利场景，从而提升员工满意度，最大发挥其员工敬业精神。 ' },
        { title: '关于员工激励', text: '建立员工奖励机制，企业自由定制积分额度。通过奖励积分的发放，用于实时激励员工。一定程度上增强了企业与员工之间的互动，积极宣导企业文化。 ' },
        { title: '关于福利商城', text: '人性化内购福利商城，专业团队开发与维护。企业可根据自身需求，自主设置所需模块，以满足不同企业的个性化需求。' },
      ],
      componentsArr: ['Compare', 'Welfare', 'Compare', 'Care', 'Stimulate', 'Mall'],
      comName: 'Compare',
      type: 1
    }
  },
  components: {
    Compare,
    Welfare,
    Care,
    Stimulate,
    Mall,
  },
  methods: {
    proEnter(i) {
      this.nowPro = i;
      this.comName = this.componentsArr[i];
      if (i === 0) {
        this.type = 1;
        return false;
      }
      if (i === 2) {
        this.type = 2;
        return false;
      }
    }
  }
}
</script>
<style scoped lang="less">
#programme {
  .banner {
    height: 355px;
    width: 100%;
    overflow: hidden;
    text-align: center;
    position: relative;
    img {
      height: 355px;
      width: 1920px;
      margin: 0 -100%;
    }
    .text {
      position: absolute;
      z-index: 1;
      top: 0;
      width: 100%;
      height: 100%;
      text-align: left;
      color: @white;
      div {
        width: 1200px;
        height: 100%;
        margin: 0 auto;
      }
      p {
        font-size:48px;
        font-family: @PingFangSC-Semibold;
        font-weight:600;
        line-height:67px;
        margin-top: 140px;
      }
    }
  }
  .center {
    width: 1200px;
    height: 100%;
    margin: 0 auto;
    text-align: center;
    h3 {
      font-size:30px;
      font-family: @PingFangSC-Semibold;
      font-weight:600;
      color:@text-color;
      line-height:42px;
    }
  }
  .tab {
    height: 258px;
    width: 100%;
    .center {
      ul {
        padding-top: 60px;
        li {
          width:186px;
          height:84px;
          background:rgba(255,255,255,1);
          border:1px solid rgba(227,227,227,1);
          line-height: 84px;
          margin-right: 14px;
          font-size: 0px;
          cursor: pointer;
          img {
            display: inline-block;
            vertical-align: middle;
            height: 35px;
            width: 35px;
            margin-right: 17px;
          }
          span {
            display: inline-block;
            vertical-align: middle;
            font-size:18px;
            font-family: @PingFangSC-Regular;
            font-weight:400;
            color:@text-color;
          }
        }
        li:last-child {
          margin-right: 0px;
        }
        .active {
          background: rgba(240,171,41,1);
          background:linear-gradient(360deg,rgba(240,171,41,1) 0%,rgba(248,209,73,1) 100%);
          span {
            color: @white;
          }
        }
      }
    }
  }
  .intro {
    height: 264px;
    width: 100%;
    .center {
      background: url('@{image}us-bg.png') no-repeat center center / 1097px 264px;
      h3 {
        margin: 18px 0px 30px;
      }
      .content {
        p {
          margin: 0 auto;
          font-size:18px;
          font-family: @PingFangSC-Regular;
          font-weight:400;
          color:@text-color;
          width: 790px;
          line-height:40px;
          letter-spacing:1px;
        }
      }
    }
  }
  .guard {
    height: 415px;
    width: 100%;
    background:rgba(246,247,250,1);
    .center {
      overflow: hidden;
      padding: 0 10px;
      h3 {
        margin: 40px 0px 67px;
      }
      .content {
        ul {
          overflow: hidden;
          li {
            width:380px;
            height:157px;
            background:rgba(255,255,255,1);
            border-radius:2px;
            margin-right: 20px;
            overflow: hidden;
            color:@text-color;
            .msg {
              padding: 33px 34px 0px 38px;
              img {
                height: 55px;
                width: 55px;
                margin-bottom: 4px;
              }
              p {
                font-size:18px;
                font-family: @PingFangSC-Semibold;
                font-weight:600;
                line-height:25px;
              }
            }
            .list {
              width: 230px;
              font-size: 0px;
              padding-top: 21px;
              text-align: left;
              span {
                display: inline-block;
                font-size:14px;
                font-family: @PingFangSC-Regular;
                font-weight:400;
                line-height:20px;
                margin-right: 42px;
                margin-bottom: 12px;
              }
            }
          }
          li:last-child {
            background: url('@{image}/service3.png') no-repeat center center / 380px 157px;
            margin-right: 0px;
          }
          li:nth-child(1) {
            background: url('@{image}/service1.png') no-repeat center center / 380px 157px;
          }
          li:nth-child(2) {
            background: url('@{image}/service2.png') no-repeat center center / 380px 157px;
            .list {
              span {
                width: 100px;
                margin-right: 8px;
                margin-bottom: 22px;
              }
            }
          }

        }
      }
    }
  }
}
</style>
